/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as InviteTokenRouteImport } from './routes/invite.$token'
import { Route as AuthShutdownRouteImport } from './routes/_auth/shutdown'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthReviewRouteImport } from './routes/_auth/review'
import { Route as AuthPlanRouteImport } from './routes/_auth/plan'
import { Route as AuthGoalsRouteImport } from './routes/_auth/goals'
import { Route as AuthDashboardRouteImport } from './routes/_auth/dashboard'
import { Route as AuthCircleRouteImport } from './routes/_auth/circle'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthShutdownRoute = AuthShutdownRouteImport.update({
  id: '/shutdown',
  path: '/shutdown',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthReviewRoute = AuthReviewRouteImport.update({
  id: '/review',
  path: '/review',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPlanRoute = AuthPlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGoalsRoute = AuthGoalsRouteImport.update({
  id: '/goals',
  path: '/goals',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDashboardRoute = AuthDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCircleRoute = AuthCircleRouteImport.update({
  id: '/circle',
  path: '/circle',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/circle': typeof AuthCircleRoute
  '/dashboard': typeof AuthDashboardRoute
  '/goals': typeof AuthGoalsRoute
  '/plan': typeof AuthPlanRoute
  '/review': typeof AuthReviewRoute
  '/settings': typeof AuthSettingsRoute
  '/shutdown': typeof AuthShutdownRoute
  '/invite/$token': typeof InviteTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/circle': typeof AuthCircleRoute
  '/dashboard': typeof AuthDashboardRoute
  '/goals': typeof AuthGoalsRoute
  '/plan': typeof AuthPlanRoute
  '/review': typeof AuthReviewRoute
  '/settings': typeof AuthSettingsRoute
  '/shutdown': typeof AuthShutdownRoute
  '/invite/$token': typeof InviteTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/circle': typeof AuthCircleRoute
  '/_auth/dashboard': typeof AuthDashboardRoute
  '/_auth/goals': typeof AuthGoalsRoute
  '/_auth/plan': typeof AuthPlanRoute
  '/_auth/review': typeof AuthReviewRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/shutdown': typeof AuthShutdownRoute
  '/invite/$token': typeof InviteTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/circle'
    | '/dashboard'
    | '/goals'
    | '/plan'
    | '/review'
    | '/settings'
    | '/shutdown'
    | '/invite/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/circle'
    | '/dashboard'
    | '/goals'
    | '/plan'
    | '/review'
    | '/settings'
    | '/shutdown'
    | '/invite/$token'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/login'
    | '/_auth/circle'
    | '/_auth/dashboard'
    | '/_auth/goals'
    | '/_auth/plan'
    | '/_auth/review'
    | '/_auth/settings'
    | '/_auth/shutdown'
    | '/invite/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
  InviteTokenRoute: typeof InviteTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/shutdown': {
      id: '/_auth/shutdown'
      path: '/shutdown'
      fullPath: '/shutdown'
      preLoaderRoute: typeof AuthShutdownRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/review': {
      id: '/_auth/review'
      path: '/review'
      fullPath: '/review'
      preLoaderRoute: typeof AuthReviewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/plan': {
      id: '/_auth/plan'
      path: '/plan'
      fullPath: '/plan'
      preLoaderRoute: typeof AuthPlanRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/goals': {
      id: '/_auth/goals'
      path: '/goals'
      fullPath: '/goals'
      preLoaderRoute: typeof AuthGoalsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/dashboard': {
      id: '/_auth/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AuthDashboardRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/circle': {
      id: '/_auth/circle'
      path: '/circle'
      fullPath: '/circle'
      preLoaderRoute: typeof AuthCircleRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthCircleRoute: typeof AuthCircleRoute
  AuthDashboardRoute: typeof AuthDashboardRoute
  AuthGoalsRoute: typeof AuthGoalsRoute
  AuthPlanRoute: typeof AuthPlanRoute
  AuthReviewRoute: typeof AuthReviewRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthShutdownRoute: typeof AuthShutdownRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCircleRoute: AuthCircleRoute,
  AuthDashboardRoute: AuthDashboardRoute,
  AuthGoalsRoute: AuthGoalsRoute,
  AuthPlanRoute: AuthPlanRoute,
  AuthReviewRoute: AuthReviewRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthShutdownRoute: AuthShutdownRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  InviteTokenRoute: InviteTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
